import { MutationTree } from 'vuex';
import { ITakeTeilnehmerState } from './state';
import { BenutzerInfoSearchResultApiDto, TakeTeilnehmerApiDto, TeilnehmerListApiDto } from '@/api-schema';
import { TeilnehmerFilterDto } from '@/types/TeilnehmerFilterDto';

export const MAPTakeTeilnehmerDATA = 'mapTakeTeilnehmerApiDtoData';
export const ADD_TEILNEHMERLIST = 'addTeilnehmerList';
export const MAP_TEILNEHMERLIST = 'mapTeilnehmerList';
export const CLEAR_TEILNEHMERFILTER = 'clearTeilnehmerFilter';
export const APPLY_TEILNEHMERFILTER = 'mapTeilnehmerFilter';
export const LOADING_BENUTZER = 'mapBenutzerLoading';
export const MAPBENUTZERDATA = 'mapBenutzerData';
export const LOADING_TEILNEHMER = 'mapTeilnehmerLoading';
export const OFFSET_TEILNEHMER = 'mapTeilnehmerOffset';
export const TOTAL_NUMBER_OF_RECORDS_TEILNEHMER = 'totalNumberOfRecordsTeilnehmer';

export const mutations: MutationTree<ITakeTeilnehmerState> = {
    [MAPTakeTeilnehmerDATA](state, value: TakeTeilnehmerApiDto) {
        state.teilnehmer = value;
    },
    [ADD_TEILNEHMERLIST](state, value: Array<TeilnehmerListApiDto>) {
        state.teilnehmerList = state.teilnehmerList.concat(value);
    },
    [MAP_TEILNEHMERLIST](state, value: Array<TeilnehmerListApiDto>) {
        state.teilnehmerList = value;
    },
    [CLEAR_TEILNEHMERFILTER](state) {
        state.teilnehmerFilter = new TeilnehmerFilterDto();
    },
    [APPLY_TEILNEHMERFILTER](state, value: TeilnehmerFilterDto) {
        state.teilnehmerFilter.status = value.status;
        state.teilnehmerFilter.suchText = value.suchText;
        state.teilnehmerFilter.hatRechnungenNurViaVetdata = value.hatRechnungenNurViaVetdata;
        state.teilnehmerFilter.hatTvsDokumenteNurDigital = value.hatTvsDokumenteNurDigital;
        state.teilnehmerFilter.suchText = value.suchText;
        state.teilnehmerFilter.sortBy = value.sortBy;
        state.teilnehmerFilter.sortOrder = value.sortOrder;
        state.teilnehmerFilter.offset = 0;
    },
    [OFFSET_TEILNEHMER](state, value: number) {
        state.teilnehmerFilter.offset = value;
    },
    [LOADING_BENUTZER](state, value: boolean) {
        state.benutzerLoading = value;
    },
    [MAPBENUTZERDATA](state, benutzerInfoSearchResultApiDto: BenutzerInfoSearchResultApiDto) {
        state.benutzerInfoSearchResultApiDto = benutzerInfoSearchResultApiDto;
    },
    [LOADING_TEILNEHMER](state, value: boolean) {
        state.teilnehmerLoading = value;
    },
    [TOTAL_NUMBER_OF_RECORDS_TEILNEHMER](state, value: number) {
        state.teilnehmerTotalNumberOfRecords = value;
    }
};
